import { render, staticRenderFns } from "./pet-policy-form.vue?vue&type=template&id=5bcdde78&scoped=true&"
import script from "./pet-policy-form.vue?vue&type=script&lang=js&"
export * from "./pet-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./pet-policy-form.vue?vue&type=style&index=0&id=5bcdde78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcdde78",
  null
  
)

export default component.exports